export class ChaseAmountDetail {
  chaseId: number;
  amountPerChase: number;
  constructor(options: Partial<ChaseAmountDetail>) {
    this.chaseId = options.chaseId;
    this.amountPerChase = options.amountPerChase;
  }
}
